export const nameSpace = 'visitor-types';
